import type { ReactNode } from "react";

import { ErrorBoundaryWithLogging } from "app/pages/sales-intelligence/common-components/ErrorBoundaryWithLogging";
import Card from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/Card";

interface ICardErrorBoundaryProps {
    dataAutomation: string;
    children: ReactNode;
    header?: ReactNode;
    footer?: ReactNode;
    width?: string;
    fallbackContent?: ReactNode;
}

export const CardErrorBoundary = ({
    dataAutomation,
    children,
    header,
    footer,
    width,
    fallbackContent,
}: ICardErrorBoundaryProps) => (
    <ErrorBoundaryWithLogging
        fallback={
            <Card
                dataAutomation={dataAutomation}
                header={header}
                footer={footer}
                width={width}
                isEmpty
                emptyState={fallbackContent}
                renderContent={() => null}
            />
        }
    >
        {children}
    </ErrorBoundaryWithLogging>
);
